import React from 'react';
import { Box } from '@material-ui/core';
import DeleteDark from 'src/assets/images/DeleteDark.svg';
import { makeStyles } from '@material-ui/core/styles';
import edit from 'src/assets/images/Edit.svg';
import RowItemContainer from './RowContainerDesktop';
import { useTranslation } from 'react-i18next';
import NoItemTableData from 'src/pages/reportUsage/common/NoData';
import CustomLabel from 'src/pages/reportUsage/common/customLabel/CustomLabel';
import { useAdjQtyLabel } from 'src/common/hooks/useAdjQtyLabel';
import { useRef } from 'react';

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
    paper: {
        padding: '15px 30px 15px 17px',
    },
    image: {
        width: 128,
        height: 128,
    },
    img: {
        margin: 'auto',
        display: 'block',
        maxWidth: '100%',
        maxHeight: '100%',
    },
    gridPadBottom: {
        paddingBottom: 8,
    },
}));
const ItemsListContainerDesktop = (props) => {
    const {
        toggleHidePricesBtn,
        filteredProduct,
        selectedChildEditItem,
        selectedChildItem,
        selectedChildIndex,
        onAccountOwnedSeleted,
        onIsSerialUnknown,
        deleteAll,
        deleteItem,
        editItem,
        editChildItem,
        editedChildItemList,
        addSerialNumber,
        editedItemList,
        lotSerialValueEntered,
        showBundlefromTableList,
        bundleExpandCollapseIconClickHandler,
        vendorCaseErrorRedirection,
    } = props;
    const classes = useStyles();
    const { t } = useTranslation();
    const adjQtyLabel = useAdjQtyLabel();
    const flexStyleObj = { display: 'flex', justifyContent: 'space-between' };
       
    return (
        <React.Fragment>
            {filteredProduct?.length !== 0 ? (
                <div>
                    <Box
                        className={classes.paper}
                        my={1}
                        bgcolor={'#ffffff'}
                        box-shadow={'0px 1px 2px #00000029'}
                        borderRadius={'6px 6px 0 0'}
                        style={{
                            fontFamily: 'AvenirNextWorld Demi',
                            fontSize: '13px',
                            letterSpacing: '0px',
                            color: '#3c3c3c',
                            opacity: '1',
                        }}
                        height={'48px'}
                    >
                        <div style={{ display: 'flex' }}>
                            <div
                                style={{
                                    width: '256px',
                                    marginRight: '48px',
                                    ...flexStyleObj,
                                }}
                            >
                                <span>
                                    {t('reportUsage.itemList.productName')}
                                </span>
                                <span
                                // style={{
                                //     paddingRight:
                                //         !isLanguageChanged && '40px',
                                // }}
                                >
                                    {t('reportUsage.itemList.uom')}
                                </span>
                            </div>
                            <div
                                style={{
                                    width: '312px',
                                    marginRight: '42px',
                                    display: 'flex',
                                }}
                            >
                                {/* Fixed columns mirror the row layout so Used/Adj
                                    labels align over their 48px input boxes. */}
                                <div
                                    style={{
                                        width: '152px',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    {t('reportUsage.itemList.lotorserial')}
                                </div>
                                <div
                                    style={{
                                        width: '160px',
                                        boxSizing: 'border-box',
                                        paddingLeft: '5px',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                    }}
                                >
                                    <div
                                        style={{
                                            width: '48px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {t('reportUsage.itemList.used')}
                                    </div>
                                    <div
                                        style={{
                                            width: '48px',
                                            textAlign: 'center',
                                        }}
                                    >
                                        {t(adjQtyLabel('reportUsage.itemList.other'))}
                                    </div>
                                    <div
                                        style={{
                                            width: '40px',
                                            display: 'flex',
                                            justifyContent: 'center',
                                        }}
                                    >
                                        <img
                                            src={DeleteDark}
                                            style={{
                                                width: 24,
                                                height: 24,
                                                cursor: 'pointer',
                                            }}
                                            onClick={deleteAll}
                                            id={`delete-all-${filteredProduct?.length}`}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div style={{ width: '80px', marginRight: '40px' }}>
                                {t('reportUsage.itemList.accountOwned')}
                            </div>
                            <div style={{ width: '286px', ...flexStyleObj }}>
                                <div style={{ paddingLeft: '8px' }}>
                                    {t('common.qty')}
                                </div>
                                <div>{t('reportUsage.itemList.unitPrice')}</div>
                                <div>{t('reportUsage.itemList.exitPrice')}</div>
                            </div>
                        </div>
                    </Box>
                    {filteredProduct &&
                        filteredProduct.map((item, index) => {
                            return (
                                <>
                                    <RowItemContainer
                                        key={`${item.cfn} ${index}`}
                                        classes={classes}
                                        item={item}
                                        index={index}
                                        edit={edit}
                                        editItem={editItem}
                                        editedItemList={editedItemList}
                                        addSerialNumber={addSerialNumber}
                                        lotSerialValueEntered={
                                            lotSerialValueEntered
                                        }
                                        onAccountOwnedSeleted={
                                            onAccountOwnedSeleted
                                        }
                                        onIsSerialUnknown={onIsSerialUnknown}
                                        deleteItem={deleteItem}
                                        displayPrice={
                                            toggleHidePricesBtn === 'hideBtn'
                                        }
                                        showBundlefromTableList={
                                            showBundlefromTableList
                                        }
                                        editChildItem={editChildItem}
                                        selectedChildItem={selectedChildItem}
                                        selectedChildEditItem={
                                            selectedChildEditItem
                                        }
                                        selectedChildIndex={selectedChildIndex}
                                        editedChildItemList={
                                            editedChildItemList
                                        }
                                        bundleExpandCollapseIconClickHandler={
                                            bundleExpandCollapseIconClickHandler
                                        }
                                        vendorCaseErrorRedirection={
                                            vendorCaseErrorRedirection
                                        }
                                       
                                    />
                                  
                                </>
                            );
                        })}
                </div>
            ) : (
                <NoItemTableData
                    padding="8px 0px"
                    content={t('reportUsage.noUsageItemsMsg')}
                />
            )}
        </React.Fragment>
    );
};

export default ItemsListContainerDesktop;
